import { Separator } from '@/components/ui/separator';
// import isInRole from '@/hooks/use-auth';
import { useMsal } from '@azure/msal-react';

export function Auth() {
	const { instance, accounts, inProgress } = useMsal();

	if (accounts.length > 0) {
		return (
			<span>
				There are currently {accounts.length} users signed in!
				<div>
					<button onClick={() => instance.logout()}>Logout</button>
				</div>
				<div>
					{accounts.map((account) => {
						return (
							<div key={account.localAccountId} className="flex flex-col space-y-2">
								<p>Account Name: {account.name}</p>
								<p>Account Username: {account.username}</p>
								<Separator />
								<p>Account Home Account Id: {account.homeAccountId}</p>
								<p>Account Environment: {account.environment}</p>
								<p>Account Tenant Id: {account.tenantId}</p>
								<p>Account Local Account Id: {account.localAccountId}</p>
								<p>Account Id Token: {account.idToken}</p>
								<p>
									Account Local Account Id:{' '}
									{JSON.stringify(account.idTokenClaims, null, 2)}
								</p>
								<p>Account Local Account Id: {account.nativeAccountId}</p>
							</div>
						);
					})}
				</div>
				<Separator />
				<p className="text-lg font-bold">{accounts?.at(0)?.name} in Roles:</p>
				{/* <div className="flex">
					<div className="w-32 flex-none">Admin</div>
					<div>{isInRole('Admin') ? 'Yes' : 'No'}</div>
				</div>
				<div className="flex">
					<div className="w-32 flex-none">PIPS</div>
					<div>{isInRole('PIPS') ? 'Yes' : 'No'}</div>
				</div>
				<div className="flex">
					<div className="w-32 flex-none">Blackline</div>
					<div>{isInRole('Blackline') ? 'Yes' : 'No'}</div>
				</div>
				<div className="flex">
					<div className="w-32 flex-none">Producer</div>
					<div>{isInRole('Producer') ? 'Yes' : 'No'}</div>
				</div> */}
			</span>
		);
	} else if (inProgress === 'login') {
		return <span>Login is currently in progress!</span>;
	} else {
		return (
			<>
				<span>There are currently no users signed in!</span>
				<button onClick={() => instance.loginPopup()}>Login</button>
			</>
		);
	}
}
